export default class AlertsActionsContentController {
    /** @ngInject */
    constructor(EventEmitter, DialogService) {
        this.eventEmmiter = EventEmitter;
        this.dialogService = DialogService;
    }

    $onInit() {
        if (!this.rule) {
            this.rule = {};
        }
    }

    $onChanges(changes) {
        if (changes.rule.currentValue) {
            this.rule = changes.rule.currentValue;
        }
    }

    cancel() {
        this.onCancel(
            this.eventEmmiter({
                rule: this.rule
            })
        );
    }

    remove() {
        this.dialogService.confirm({
            title: 'Delete Rule?',
            textContent: `Do you really want to delete rule "${this.rule.name}"?`,
            ariaLabel: 'delete-rule',
            ok: 'Delete',
            cancel: 'Cancel'
        }).then(() => {
            this.onRemove(
                this.eventEmmiter({
                    id: this.rule.id
                })
            );
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/alerts-actions-content.controller.js